import React from "react";
import Reveal from "./Reveal";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "../../lib/track";
import { amazonBookLinkProps } from "../../lib/externalLinks";

/**
 * The Book: The Philosophy Behind the Movement.
 *
 * Repositions the book as the philosophical layer underneath the
 * sessions, sprints, and strategic work, rather than the primary
 * entry point. The book remains a real product with a real Stripe
 * checkout - the primary CTA still routes to /book and the
 * secondary CTA fires the existing book-checkout event so the
 * hero-level "Reserve a copy" affordance still works from this
 * homepage section.
 *
 * Replaces the older FounderNoteSection on the homepage. The
 * editorial framing (charcoal panel, gold hairlines, italic
 * gradient on the key phrase) matches the rest of the site.
 */

const BookPhilosophy = () => (
  <section
    id="book-philosophy"
    data-testid="book-philosophy-section"
    className="relative py-24 md:py-32 border-t border-gold/10"
  >
    <div className="max-w-5xl mx-auto px-6 md:px-10">
      <Reveal>
        <p className="text-[11px] tracking-[0.5em] uppercase text-gold mb-6 text-center">
          The Book
        </p>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-themed leading-tight tracking-tight font-light text-center max-w-3xl mx-auto">
          The philosophy behind the{" "}
          <span className="italic gold-gradient-text">movement.</span>
        </h2>
      </Reveal>

      <Reveal delay={160}>
        <div className="mt-12 bg-white/5 border-t border-gold/20 p-8 md:p-10 rounded-lg border border-gold/10">
          <p className="text-white/85 text-[16.5px] md:text-[17.5px] leading-relaxed">
            Authentic Momentum began as a way to understand how people move from inner misalignment to external movement.
          </p>
          <p
            data-testid="book-philosophy-ecosystem-line"
            className="mt-5 text-white/85 text-[16.5px] md:text-[17.5px] leading-relaxed"
          >
            The book gives language to the philosophy. The free Clarity Snapshot helps you locate yourself inside it. The paid offers help you apply it to your actual decisions, projects, and next moves.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-3">
            <a
              href="/book"
              data-testid="book-philosophy-explore"
              onClick={() => trackEvent("book_philosophy_explore_clicked")}
              className="btn-gold inline-flex items-center gap-2"
            >
              Explore the Book <ArrowRight size={14} />
            </a>
            <a
              {...amazonBookLinkProps}
              data-testid="book-philosophy-reserve"
              onClick={() => trackEvent("book_philosophy_amazon_clicked")}
              className="btn-ghost-gold inline-flex items-center gap-2"
            >
              Buy on Amazon
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default BookPhilosophy;
